import type { TError, TEventBase } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export const getCommunityEventQueryKey = (contentBlockId: string) => [ENTITY, 'events', contentBlockId];

export const useGetEvent = (contentBlockId: string) => {
  return useQuery<TEventBase, TError>({
    queryKey: getCommunityEventQueryKey(contentBlockId),
    queryFn: async () => {
      const res = await axios.get<TEventBase>(`/community-hub/events/${contentBlockId}`);
      return res.data;
    },
    enabled: !!contentBlockId,
    staleTime: 60 * 1000,
  });
};
